/* eslint complexity: [1, 12] */
import KeyCodes from '../../_patterns/00-base/global/utils/keycodes';
import sectionState from '../../_patterns/00-base/global/utils/form/section-state';
import { inputCheck, inputMatch } from '../../_patterns/00-base/global/utils/form/input-validation';
import hInc from '../../_patterns/00-base/global/utils/form/h-tag-incrementer';


/**
 * Initialises booking form functionality.
 */
export default function(documentScroller) {
  const form_sections = [...document.getElementsByClassName('js-form-section')];
  const progress_items = [...document.getElementsByClassName('js-progress-bar-item')];
  const state = sectionState(form_sections.length);
  const all_inputs = [...document.querySelectorAll('.js-form-section input, .js-form-section textarea')];
  const all_dropdowns = [...document.querySelectorAll('.js-form-section .js-dropdown')];
  const all_buttons = [...document.querySelectorAll('.js-form-section__btn .button')];
  const form = document.getElementsByClassName('js-form')[0];
  const thankyou = document.getElementsByClassName('js-form-thankyou')[0];
  const keys = new KeyCodes();
  let is_debug = false;

  if (window.location.hash === '#debug') {
    localStorage.setItem('debug', 1);
    console.log('Debug mode has been enabled');
  }

  if (window.location.hash === '#no-debug') {
    localStorage.removeItem('debug');
    console.log('Debug mode has been disabled');
  }

  is_debug = localStorage.getItem('debug') ? true : false;

  if (is_debug) {
    console.log('You are now in debug mode. The next button will work even with invalid input');
  }

  [...document.getElementsByClassName('js-form__btn--review')].forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      state.goto(form_sections.length);
    });
  });

  // if enter pressed on progress bar item that is focused trigger click on it
  document.addEventListener('keydown', e => {
    if (e.keyCode === 13 && progress_items.indexOf(document.activeElement) >= 0) {
      document.activeElement.click();
    }
  });


  // only visited progress bar items can be used for navigation
  progress_items.forEach((item, index) => {
    item.addEventListener('click', e => {
      if (e.currentTarget.classList.contains('progress-bar-item--visited')) {
        state.goto(index);
      };
    });
  });


  // on change of state update the progress bar
  state.onChange(section_number => {

    // adds visited state to the previous section that has just been left
    if (progress_items[section_number - 1]) {
      progress_items[section_number - 1].classList.add('progress-bar-item--visited');
      progress_items[section_number - 1].setAttribute('tabindex', 0);
    }

    // adds visited state to the last review section
    if (section_number === progress_items.length - 1) {
      progress_items[section_number].classList.add('progress-bar-item--visited');
      progress_items[section_number].setAttribute('tabindex', 0);
    }

    progress_items.forEach(item => item.classList.remove('progress-bar-item--active'));
    progress_items[section_number].classList.add('progress-bar-item--active');
  });

  // disable all the inputs and change buttons on disabled state
  state.onDisable(() => {
    form_sections.forEach(item => item.classList.add('form-section--active'));
    form_sections.forEach(item => item.classList.remove('form-section--fade-out'));
    all_inputs.forEach(input => input.setAttribute('disabled', true));
    all_dropdowns.forEach(dropdown => dropdown.classList.add('dropdown--disabled'));
    form.classList.add('form--review');
    form.classList.add('form--reviewed-once');

    hInc(form.querySelectorAll('.form-section h1, .form-section h2, .form-section h3, .form-section h4, .form-section h5, .form-section h6'));

    all_buttons.forEach(btn => {
      btn.textContent = 'Edit';
      btn.classList.add('button--no-arrow');
    });
  });


  /**
   * Funnction that toggles from one section to another.
   * @param  {DOMElement} next next section
   * @param  {DOMElement}   prev previous section
   * @param  {Boolean}  is_last is the element last?
   */
  function toggleSection(next, prev, is_last) {
    let height = 0;

    if (!prev) {
      height = form.getBoundingClientRect().height;
    } else {
      height = prev.getBoundingClientRect().height;
    }

    form.style.height = `${height}px`;
    window.scrollTo(0, 0);

    if (!prev) {
      form_sections.forEach(item => item.classList.add('form-section--fade-out'));
    } else {
      prev.classList.add('form-section--fade-out');
    }

    setTimeout(() => {
      if (!prev) {
        form_sections.forEach(item => item.classList.remove('form-section--active'));
      } else {
        prev.classList.remove('form-section--active');
      }

      // review section displaying all the form section with disabled inputs and edit button
      // when you get to the last section
      if (is_last) {
        state.disable();
      } else if (state.checkDisabled()) {
        state.enable();

      }

      if (next) {
        next.classList.add('form-section--active');
      }

      form.style.height = '';

      if (next) {
        next.classList.remove('form-section--fade-out');
      }

      // focuse on the first h2 of the new section or the first h2 of the review page
      if (is_last) {
        form.getElementsByTagName('h2')[0].focus();
      } else {
        next.getElementsByTagName('h2')[0].focus();
      }

    }, 500);

  }

  // enable all the inputs and change back buttons on enabled state
  state.onEnable(() => {
    all_inputs.forEach(input => input.removeAttribute('disabled'));
    all_dropdowns.forEach(dropdown => dropdown.classList.remove('dropdown--disabled'));
    form.classList.remove('form--review');

    hInc(form.querySelectorAll('.form-section h1, .form-section h2, .form-section h3, .form-section h4, .form-section h5, .form-section h6'), true);

    all_buttons.forEach(btn => {
      btn.textContent = 'Next';
      btn.classList.remove('button--no-arrow');
    });
  });

  // on change of section number show the current one and hide the others
  state.onChange((section_number, prev_number) => {
    const is_last = section_number === form_sections.length;
    const current = form_sections[section_number];

    toggleSection(current, form_sections[prev_number], is_last);
  });

  // for each form section add click event listener for its button
  form_sections.forEach((section, index) => {
    const btn = section.getElementsByClassName('js-form-section__btn')[0];
    const btn_a = btn.getElementsByClassName('button')[0];
    const section_items = [...section.getElementsByClassName('js-form-section__item')];
    const heading = section.getElementsByClassName('js-form-heading')[0];
    const heading_id = heading.id;

    state.onDisable(() => btn_a.setAttribute('aria-labelledby', heading_id));
    state.onEnable(() => btn_a.removeAttribute('aria-labelledby'));

    btn.addEventListener('keydown', e => {
      if (e.keyCode === keys.space) {
        e.preventDefault();
        btn.click();
      }
    });

    // when user clicks next button
    btn.addEventListener('click', e => {
      let all_valid = true;
      let first_invalid;

      e.preventDefault();

      // if it's on the review page and the state is disabled use button to jump to section
      if (state.checkDisabled()) {
        state.goto(index);
        return;
      };

      // loop through all the section items and check their validity
      // if any of them is not valid show error
      // if all valid go to the next section
      section_items.forEach(item => {
        const item_type = item.dataset.type;
        const is_required = item.dataset.is_required;
        const regex_type = item.dataset.regex_type;
        const error_elem = item.getElementsByClassName('js-labelled__error')[0];

        let error_id;
        let valid = false;

        if (error_elem) {
          error_id = error_elem.id;
        }

        // different checks depending on section item type
        switch (item_type) {
          case 'radio':
          case 'dropdown-labelled':
          case 'date-dropdown':
            valid = inputCheck(item, item_type, is_required);
            break;
          case 'text-field':
          case 'text-area':
            valid = inputMatch(item, regex_type, is_required);
            break;

          // if there is no such item type it means it matches
          default:
            valid = true;
        }

        if (valid) {
          // remove the error class if item is valid
          item.classList.remove('form-section__item--error');
          [...item.querySelectorAll('input, textarea')].forEach(input => input.removeAttribute('aria-describedby'));
        } else {
          // show error class if item is not valid
          item.classList.add('form-section__item--error');
          [...item.querySelectorAll('input, textarea')].forEach(input => {
            input.setAttribute('aria-describedby', error_id);
          });

          // if at least one item is not valid the whole section is not valid
          all_valid = false;

          // store first invalid element so that you can scroll to it after the loop
          if (!first_invalid) {
            first_invalid = item;
          }
        }
      });

      // if all section items are valid proceed to the next section
      if (all_valid || is_debug) {
        state.next();
      } else {
        // scroll centering first invalid element on the page
        const messages = document.querySelector('.status-messages');

        if (messages) {
          documentScroller.scrollToElement(messages, 'top');
          messages.focus();
        }
      }
    });
  });

  // Submit
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    form.classList.add('form--submitted');
    thankyou.classList.add('form-thankyou--show');
    progress_items.forEach((item) => {
      item.classList.add('progress-bar-item--disabled');
    });
  });
};
